export default `x -= s;
  return ( x - a * floor( x / a ) ) + s;
}

void TransA( inout vec3 z, inout float DF, float a, float b ) {
  float iR = 1. / dot(z,z);
  z *= -iR;
  z.x = -b - z.x; 
  z.y =  a + z.y; 
  DF *= max( 1.0, iR );
}

float de ( vec3 z ) {
  float adjust = 6.2; 
  float box_size_x = 1.0;
  float box_size_z = 1.0;
  float KleinR = 1.94 + 0.05 * abs( sin( -adjust * 0.5 ) ); 
  float KleinI = 0.03 * cos( -adjust * 0.5 ); 
  vec3 lz = z +  vec3( 1.0 ), llz = z + vec3( -1.0 );
  float d = 0.0; float d2 = 0.0;
  float DE = 1e10;
  float DF = 1.0;
  float a = KleinR;
  float b = KleinI;
  float f = sign( b ) * 1.0;
  for ( int i = 0; i < 20 ; i++ ){
    z.x = z.x + b / a * z.y;
    z.xz = wrap( z.xz, vec2( 2.0 * box_size_x, 2.0 * box_size_z ), vec2( -box_size_x, -box_size_z ) );
    z.x = z.x - b / a * z.y;
    if ( z.y >= a * 0.5 + f * ( 2.0 * a - 1.95 ) / 4.0 * sign( z.x + b * 0.5 ) * 
     ( 1.0 - exp( -( 7.2 - ( 1.95 - a ) * 15.0 ) * abs( z.x + b * 0.5 ) ) ) ) { 
      z = vec3( -b, a, 0.0 ) - z;
    } 

    TransA( z, DF, a, b ); 
    if ( dot( z - llz, z - llz ) < 1e-5 ) { break; } 
    llz=lz; lz=z;  
  }
  
  float y =  min( z.y, a - z.y );
  DE = min( DE, min( y, 0.3 ) / max( DF, 2.0 ) );
  return DE;
}`